<template>
  <div class="form-field-doc-hint caption">
    <span v-if="hint" class="gray--text text--darken-1">{{ hint }}</span>
    <a
      v-if="showDocLink"
      :href="docUrl"
      target="_blank"
      rel="noopener"
      class="info--text"
      :class="{ 'ml-1': hint }"
    >{{ linkText }}</a>
  </div>
</template>

<script>
const DEFAULT_DOC_URL = "https://www.panelalpha.com/documentation/";

export default {
  name: "FormFieldDocHint",
  props: {
    hint: {
      type: String,
      default: "",
    },
    linkText: {
      type: String,
      required: true,
    },
    showDocLink: {
      type: Boolean,
      default: true,
    },
    docUrl: {
      type: String,
      default: DEFAULT_DOC_URL,
    },
  },
};
</script>
